import { findIndex } from 'lodash';
import api from 'src/api';

const blank = {
  customer: undefined,
  description: undefined,
  name: undefined,
  requestType: undefined,
  status: undefined,
  comment: undefined,
  insertedAt: new Date(0),
  updatedAt: new Date(0),
  fetchAt: new Date(0),
  fetching: false,
  syncAt: new Date(0),
  sync: false,
};

const data = {
  cases: [],
};

const actions = {
  fetchCase({ commit, getters }, id) {
    if (typeof getters.getCaseById(id) === 'undefined') {
      commit('CREATE_BLANK_CASE', id);
    }
    const ticket = getters.getCaseById(id);
    const now = new Date();
    if ((now - ticket.syncAt) > 5000) {
      commit('SET_FETCHING', ticket);
      return api.getCaseById(id).then((res) => {
        commit('CASE_LOADED', {
          ticket,
          response: res,
        });
      });
    }
    return ticket;
  },
};

const mutations = {
  CREATE_BLANK_CASE(state, id) {
    const ticket = {
      id,
    };
    Object.assign(ticket, blank);
    state.cases.push(ticket);
  },
  SET_FETCHING(state, ticket) {
    ticket.fetching = true;
    ticket.fetchAt = new Date();
  },
  CASE_LOADED(state, { ticket, response }) {
    ticket.name = response.name;
    ticket.description = response.description;
    ticket.activities = response.activities;
    ticket.insertedAt = response.insertedAt;
    ticket.updatedAt = response.updatedAt;
    ticket.comment = response.comment;
    ticket.fetching = false;
    ticket.sync = true;
    ticket.syncAt = new Date();
  },
};

const getters = {
  getCaseById(state) {
    const { cases } = state;
    return (id) => (cases[findIndex(cases, { id })]);
  },
};

const store = {
  namespaced: true,
  state: data,
  actions,
  mutations,
  getters,
};

export default store;
